import {Chip, SxProps, Theme} from '@mui/material';
import {CareTaskComplementary} from '../../../backend/interfaces/care-task-complementary';

export const AutonomyChip = ({task}: {task: CareTaskComplementary}) => {
  const chipSx: SxProps<Theme> = {
    backgroundColor: task.autonomyAssessmentConfiguration
      ? task.autonomyAssessmentConfiguration.backgroundColor
      : 'var(--dcm-gray)',
    color: task.autonomyAssessmentConfiguration
      ? task.autonomyAssessmentConfiguration.color
      : 'var(--dcm-white-base)',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '18px',
    height: '22px',
    width: 'min-content',
    userSelect: 'none',
    '& .MuiChip-label': {
      px: '8px',
    },
  };

  return task.autonomyAssessmentConfiguration?.name ? (
    <Chip label={task.autonomyAssessmentConfiguration?.name} sx={chipSx} />
  ) : (
    <></>
  );
};
